import "./fragment";
import "./robonomics";
import "./clipboard";
import "./modal";
import "./notification";
import web3 from "./web3";
web3();
